/* QuantroBay add-ons: sticky bundle price + Gift List popup (no third-party branding) */
(function(){
  /* ---------- 1. Sticky add-to-cart shows the selected bundle price ---------- */
  if(/\/products\//.test(location.pathname)){
    var txt=function(el){return el?el.textContent.replace(/\s+/g,' ').trim():'';};
    var syncing=false;
    var sync=function(){
      if(syncing)return;syncing=true;
      try{
        var bar=document.querySelector('.sticky-add-to-cart__bar');if(!bar)return;
        var box=bar.querySelector('.sticky-add-to-cart__price');if(!box)return;
        var act=document.querySelector('.bx-offer-wrap.bx-active');
        var qty=1;
        if(act){
          var g=act.querySelectorAll('.bx-variant-group').length;
          var m=txt(act.querySelector('.bx-offer-title')).match(/(\d+)/);
          qty=g>1?g:(m?parseInt(m[1],10):1);
        }
        var el=box.querySelector('.qb-sb');
        if(!act||qty<2){if(el)el.remove();box.classList.remove('qb-sb-on');return;}
        var now=txt(act.querySelector('.bx-discounted-price')),was=txt(act.querySelector('.bx-original-price'));
        if(!now){if(el)el.remove();box.classList.remove('qb-sb-on');return;}
        var key=qty+'|'+now+'|'+was;
        if(!el){el=document.createElement('div');el.className='qb-sb';box.appendChild(el);}
        if(el.getAttribute('data-k')!==key){
          el.setAttribute('data-k',key);el.textContent='';
          var a=document.createElement('span');a.className='price-item__group price';var b=document.createElement('bdi');b.textContent=now;a.appendChild(b);el.appendChild(a);
          if(was&&was!==now){var c=document.createElement('span');c.className='price-item__group price-item--regular compare-at-price';var d=document.createElement('bdi');d.textContent=was;c.appendChild(d);el.appendChild(c);}
          var q=document.createElement('span');q.className='qb-sb__qty';q.textContent='for '+qty+' items';el.appendChild(q);
        }
        box.classList.add('qb-sb-on');
      }finally{syncing=false;}
    };
    var t=0,queue=function(){clearTimeout(t);t=setTimeout(sync,60);};
    document.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('.bx-offer-wrap'))setTimeout(sync,120);},true);
    document.addEventListener('change',function(e){if(e.target.closest&&e.target.closest('.bx-widget, .bx-offer-wrap'))queue();},true);
    new MutationObserver(function(ms){
      for(var i=0;i<ms.length;i++){var n=ms[i].target;if(n.nodeType===1&&n.closest&&n.closest('.qb-sb'))continue;queue();return;}
    }).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
    if(document.readyState!=='loading')sync();else document.addEventListener('DOMContentLoaded',sync);
  }


  /* ---------- 3. Judge.me reviews carousel: hide when empty, native swipe, own arrows ---------- */
  (function(){
    var t0=Date.now(),loaded=document.readyState==='complete'?Date.now():0;
    window.addEventListener('load',function(){loaded=Date.now();});
    function each(){
      document.querySelectorAll('.shopify-app-block[id*="judge_me_reviews_cards"]').forEach(function(b){
        var w=b.querySelector('.jdgm-cards-carousel');if(!w)return;
        var sec=b.closest('.shopify-section')||b;
        var n=w.querySelectorAll('.jdgm-card:not(.jdgm-clone-before):not(.jdgm-clone-after)').length;
        var sk=b.querySelector('.qb-rv-skel');
        if(n>0){
          if(sk&&!w.classList.contains('jdgm-hidden'))sk.remove();
          if(sec.classList.contains('qb-rv-empty'))sec.classList.remove('qb-rv-empty');
          w.classList.add('qb-rv');
          var tr=w.querySelector('.jdgm-videos-container');
          if(tr&&!tr._qbT){
            if(!tr._qbB){tr._qbB=1;['pointerdown','touchstart','wheel','keydown'].forEach(function(ev){tr.addEventListener(ev,function(){tr._qbT=1;},{passive:true});});}
            if(tr.scrollLeft!==0)tr.scrollLeft=0;
          }
        }else if(loaded&&Date.now()-loaded>2500){
          if(sk)sk.remove();
          sec.classList.add('qb-rv-empty');
        }
      });
    }
    (function loop(){each();if(Date.now()-t0<25000)setTimeout(loop,300);})();
    document.addEventListener('click',function(e){
      var a=e.target.closest&&e.target.closest('.jdgm-cards-carousel .jdgm-arrow');if(!a)return;
      e.preventDefault();e.stopPropagation();
      var w=a.closest('.jdgm-cards-carousel'),tr=w&&w.querySelector('.jdgm-videos-container');if(!tr)return;
      tr._qbT=1;
      var c=tr.querySelector('.jdgm-card:not(.jdgm-clone-before):not(.jdgm-clone-after)');
      var step=c?c.getBoundingClientRect().width+14:300;
      var dir=(a.getAttribute('aria-label')||'').toLowerCase().indexOf('prev')>-1?-1:1;
      tr.scrollBy({left:dir*step,behavior:'smooth'});
    },true);
  })();

  /* ---------- 2. Gift List popup + teaser ---------- */
  var P=location.pathname;
  if(/^\/(cart|checkout|account|challenge|password)/.test(P)||/\/(cart|account)(\/|$)/.test(P))return;
  var LIST='YyceJe',KEY='QWnEZ7',LS='qbGiftList',DAY=864e5;
  var store={get:function(){try{return JSON.parse(localStorage.getItem(LS)||'{}');}catch(e){return {};}},set:function(o){try{localStorage.setItem(LS,JSON.stringify(o));}catch(e){}}};
  var st=store.get();
  var CODE='GIFTLIST5';
  if(/[?&](utm_source=klaviyo|_kx=)/i.test(location.search))return;
  var IMG='https://cdn.shopify.com/s/files/1/0803/2154/4438/files/snowflake-curtain-lights-1.jpg?v=1792765111&width=900';
  var GIFT='<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="8" width="17" height="4" rx="1"/><path d="M5 12v7.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V12M12 8v12.5M12 8S10.5 3.5 8 4.2C6.2 4.7 6.6 7.4 8.7 8M12 8s1.5-4.5 4-3.8c1.8.5 1.4 3.2-.7 3.8"/></svg>';
  var X='<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var COPY='<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="8" y="8" width="12" height="12" rx="2.5"/><path d="M16 8V5.5A1.5 1.5 0 0 0 14.5 4h-9A1.5 1.5 0 0 0 4 5.5v9A1.5 1.5 0 0 0 5.5 16H8"/></svg>';
  var TICK='<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var root,teaser,lastFocus,shown=false;

  function build(){
    root=document.createElement('div');root.className='qbgl';root.setAttribute('hidden','');
    root.innerHTML='<div class="qbgl__scrim" data-qbgl-close></div>'+
      '<div class="qbgl__card" role="dialog" aria-modal="true" aria-labelledby="qbgl-t qbgl-t2">'+
        '<button type="button" class="qbgl__x" data-qbgl-close aria-label="Close">'+X+'</button>'+
        '<div class="qbgl__media"><img src="'+IMG+'" alt="" loading="lazy" width="900" height="900"><span class="qbgl__tag">'+GIFT+'Christmas 2026</span></div>'+
        '<div class="qbgl__body">'+
          '<div class="qbgl__step" data-step="form">'+
            '<p class="qbgl__eyebrow">The QuantroBay Gift List</p>'+
            '<h2 class="qbgl__h" id="qbgl-t">Join and get <em>5% off</em> your first order.</h2>'+
            '<p class="qbgl__p">Plus early Black Friday access, hand-picked gift ideas and a reminder before the Christmas shipping cut-off.</p>'+
            '<form class="qbgl__form" novalidate>'+
              '<label class="qbgl__sr" for="qbgl-e">Email address</label>'+
              '<input id="qbgl-e" class="qbgl__in" type="email" name="email" autocomplete="email" inputmode="email" placeholder="Your email address" required>'+
              '<button class="qbgl__btn" type="submit"><span>Get my 5% code</span></button>'+
              '<p class="qbgl__err" role="alert" hidden></p>'+
            '</form>'+
            '<p class="qbgl__fine">No spam. Unsubscribe anytime. See our <a href="/policies/privacy-policy">Privacy Policy</a>.</p>'+
            '<button type="button" class="qbgl__no" data-qbgl-close>No thanks</button>'+
          '</div>'+
          '<div class="qbgl__step" data-step="done" hidden>'+
            '<p class="qbgl__eyebrow">Welcome to the Gift List</p>'+
            '<h2 class="qbgl__h" id="qbgl-t2">Here’s <em>5% off</em> your first order.</h2>'+
            '<div class="qbgl__code">'+
              '<div class="qbgl__code-l"><span class="qbgl__code-k">Your code</span><span class="qbgl__code-v">'+CODE+'</span></div>'+
              '<button type="button" class="qbgl__copy" data-qbgl-copy>'+COPY+'<span>Copy</span></button>'+
            '</div>'+
            '<button type="button" class="qbgl__btn qbgl__btn--red" data-qbgl-apply><span>Apply 5% to my cart</span></button>'+
            '<p class="qbgl__ok" role="status" hidden></p>'+
            '<p class="qbgl__fine">One use per customer, for first orders only. Use the same email at checkout. Also sent to your inbox.</p>'+
            '<button type="button" class="qbgl__no" data-qbgl-close>Keep shopping</button>'+
          '</div>'+
        '</div>'+
      '</div>';
    document.body.appendChild(root);
    root.addEventListener('click',function(e){
      if(e.target.closest('[data-qbgl-close]')){e.preventDefault();close();return;}
      var cp=e.target.closest('[data-qbgl-copy]');
      if(cp){var done=function(){cp.classList.add('is-done');cp.innerHTML=TICK+'<span>Copied</span>';setTimeout(function(){cp.classList.remove('is-done');cp.innerHTML=COPY+'<span>Copy</span>';},2200);};
        if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(CODE).then(done,done);}else{var ta=document.createElement('textarea');ta.value=CODE;ta.style.position='fixed';ta.style.opacity='0';document.body.appendChild(ta);ta.select();try{document.execCommand('copy');}catch(x){}ta.remove();done();}
        return;}
      var ap=e.target.closest('[data-qbgl-apply]');
      if(ap&&!ap.disabled){ap.disabled=true;ap.classList.add('is-busy');
        fetch('/discount/'+CODE,{credentials:'same-origin'}).then(function(){
          var s2=store.get();s2.applied=1;store.set(s2);
          ap.classList.remove('is-busy');ap.classList.add('is-done');ap.innerHTML=TICK+'<span>Applied to your cart</span>';
          var ok=root.querySelector('.qbgl__ok');ok.textContent='5% off will show at checkout when you use the same email.';ok.hidden=false;
        }).catch(function(){ap.disabled=false;ap.classList.remove('is-busy');});
      }
    });
    root.addEventListener('keydown',function(e){
      if(e.key==='Escape'){close();return;}
      if(e.key==='Tab'){var f=[].slice.call(root.querySelectorAll('button,input,a[href]')).filter(function(x){return x.offsetParent;});if(!f.length)return;var a=f[0],z=f[f.length-1];if(e.shiftKey&&document.activeElement===a){e.preventDefault();z.focus();}else if(!e.shiftKey&&document.activeElement===z){e.preventDefault();a.focus();}}
    });
    root.querySelector('form').addEventListener('submit',submit);
  }
  function buildTeaser(){
    teaser=document.createElement('div');teaser.className='qbgl-tz';teaser.setAttribute('hidden','');
    teaser.innerHTML='<button type="button" class="qbgl-tz__open">'+GIFT+'<span>Gift List</span></button><button type="button" class="qbgl-tz__x" aria-label="Hide Gift List">'+X+'</button>';
    document.body.appendChild(teaser);
    teaser.querySelector('.qbgl-tz__open').addEventListener('click',function(){open(true);});
    teaser.querySelector('.qbgl-tz__x').addEventListener('click',function(){teaser.hidden=true;var s=store.get();s.tz=Date.now();store.set(s);});
  }
  function showTeaser(){
    var s=store.get();if(s.applied||(s.tz&&Date.now()-s.tz<7*DAY))return;
    if(!teaser)buildTeaser();
    teaser.querySelector('.qbgl-tz__open span').textContent=s.sub?'Your 5% code':'Gift List · 5% off';
    teaser.hidden=false;
  }
  function open(manual){
    if(!root)build();
    if(teaser)teaser.hidden=true;
    if(store.get().sub){root.querySelector('[data-step=form]').hidden=true;root.querySelector('[data-step=done]').hidden=false;}
    lastFocus=document.activeElement;root.hidden=false;
    requestAnimationFrame(function(){root.classList.add('is-open');});
    document.documentElement.classList.add('qbgl-lock');
    setTimeout(function(){var i=root.querySelector('.qbgl__in');if(i&&!root.querySelector('[data-step=form]').hidden&&window.matchMedia('(min-width:750px)').matches)i.focus();else root.querySelector('.qbgl__x').focus();},250);
    shown=true;
  }
  function close(){
    if(!root||root.hidden)return;
    root.classList.remove('is-open');document.documentElement.classList.remove('qbgl-lock');
    setTimeout(function(){root.hidden=true;},220);
    var s=store.get();
    if(!s.sub){s.closed=Date.now();store.set(s);}
    showTeaser();
    if(lastFocus&&lastFocus.focus)try{lastFocus.focus();}catch(e){}
  }
  function submit(e){
    e.preventDefault();
    var f=e.target,inp=f.querySelector('input'),err=f.querySelector('.qbgl__err'),btn=f.querySelector('button');
    var email=(inp.value||'').trim();
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)){err.textContent='Please enter a valid email address.';err.hidden=false;inp.focus();return;}
    err.hidden=true;btn.disabled=true;btn.classList.add('is-busy');
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+KEY,{method:'POST',headers:{'Content-Type':'application/vnd.api+json',revision:'2024-10-15'},
      body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'QuantroBay Gift List popup',profile:{data:{type:'profile',attributes:{email:email}}}},relationships:{list:{data:{type:'list',id:LIST}}}}})})
    .then(function(r){if(!r.ok&&r.status!==202)throw new Error(r.status);
      try{if(window.klaviyo&&window.klaviyo.identify)window.klaviyo.identify({email:email});}catch(x){}
      try{var fd=new URLSearchParams();fd.append('form_type','customer');fd.append('utf8','✓');fd.append('contact[email]',email);fd.append('contact[tags]','newsletter,gift-list');fetch('/contact',{method:'POST',body:fd,credentials:'same-origin'}).catch(function(){});}catch(x){}
      var s=store.get();s.sub=1;store.set(s);
      root.querySelector('[data-step=form]').hidden=true;root.querySelector('[data-step=done]').hidden=false;
      root.querySelector('[data-qbgl-copy]').focus();
    })
    .catch(function(){err.textContent='Something went wrong. Please try again.';err.hidden=false;})
    .then(function(){btn.disabled=false;btn.classList.remove('is-busy');});
  }
  function arm(){
    var s=store.get();
    if(s.sub||(s.closed&&Date.now()-s.closed<7*DAY)){showTeaser();return;}
    var fired=false,go=function(){if(fired||shown)return;fired=true;window.removeEventListener('scroll',onS);open(false);};
    var onS=function(){var h=document.documentElement;if((h.scrollTop+innerHeight)/h.scrollHeight>0.5)go();};
    setTimeout(go,12000);window.addEventListener('scroll',onS,{passive:true});
  }
  if(document.readyState==='complete')arm();else window.addEventListener('load',arm);
  window.qbGiftList={open:function(){open(true);}};
})();
